import React from 'react';
import GolfSoloCompleteTemplate from '../components/template/golfSoloCompleteTemplate';
import common from "../resources/js/common/common"
import '../resources/css/soloReserve/golfSoloComplete.css'
import { golfReservationList, soloReservationList } from '../const';
class GolfSoloComplete extends React.Component {

    constructor(props) {
        super(props);
        this.state = { 
            popupDataList: [],
            golfReservationPopup : false,
        };
    };

    render() {

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(soloReservationList, { userId : loginId }, afterSoloReservationList);
        }

        // 予約情報取得後処理
        const afterSoloReservationList = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reservationList,
                    }
                );
            }
        }

        return (
            <div className="soloComplete_top">
                <GolfSoloCompleteTemplate 
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                />
            </div>
        )
    }
}
export default GolfSoloComplete;